import React, { Component } from 'react'
import { Form, Field } from 'redux-form'
import { Input } from 'components/Input/Input'
import Button from 'components/Button'

export default class NumbersEdit extends Component {
  render() {
    const { service, handleSubmit, submitting, updateNumber } = this.props
    const submit = data =>
      updateNumber({
        ...service,
        customerReference: data.customerReference,
      })
    return (
      <div>
        <Form onSubmit={handleSubmit(submit)}>
          <Field
            name="customerReference"
            label="Reference name (for your use only)"
            component={Input}
          />
          <Button color="tertiary" loading={submitting} disabled={submitting} type="submit">
            Update
          </Button>
        </Form>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Numbers/NumbersEdit/NumbersEdit.jsx